import "./SubscriptionInactiveGate.css";

interface SubscriptionInactiveGateProps {
  title?: string;
  message?: string;
}

const SubscriptionInactiveGate = ({
  title = "Subscription inactive",
  message = "Your organization does not have an active subscription. Please contact the platform administrator.",
}: SubscriptionInactiveGateProps) => (
  <div className="sub-gate" role="status">
    <div className="sub-gate__icon" aria-hidden="true">
      !
    </div>
    <h3 className="sub-gate__title">{title}</h3>
    <p className="sub-gate__message">{message}</p>
  </div>
);

export default SubscriptionInactiveGate;